import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia

export * from './modules/trend-analysis.js'
export * from './modules/architecture-analysis.js'
export * from './modules/module-analysis.js'
export * from './modules/micro-journey-analysis.js'
export * from './modules/filter.js'
export * from './modules/dashboard.js'
